import { render, staticRenderFns } from "./address-verification-component.vue?vue&type=template&id=761d2f1c&"
import script from "./address-verification-component.vue?vue&type=script&lang=tsx&"
export * from "./address-verification-component.vue?vue&type=script&lang=tsx&"
import style0 from "./address-verification-component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports